import { Head, Link, router } from "@inertiajs/react"
import ProductionHeader from "@/components/admin/production/ProductionHeader"
import { Button } from "@/components/ui/button"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import type { SharedProductionProps } from "@/components/admin/production/types"

interface BatchSummary {
  id: number
  label: string
  produced_on: string | null
  total_units: number
  direct_cost_cents: number
  variant_count: number
}

interface IndexProps extends SharedProductionProps {
  batches: BatchSummary[]
}

function formatEuros(cents: number): string {
  return (cents / 100).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
  })
}

export default function BatchesIndex({ store, paths, batches }: IndexProps) {
  return (
    <>
      <Head title="Production · Batches" />
      <ProductionHeader
        title="Batches de production"
        subtitle="Historique des séries produites et de leurs coûts directs."
        storeName={store.name ?? undefined}
        paths={paths}
        actions={
          <Link href={`${paths.batches_index}/new`}>
            <Button size="sm">+ Nouveau batch</Button>
          </Link>
        }
      />
      <main className="mx-auto max-w-6xl px-6 py-8">
        {batches.length === 0 ? (
          <div className="rounded-lg border border-dashed border-gray-300 p-10 text-center">
            <p className="text-sm text-gray-500">
              Aucun batch enregistré pour l&rsquo;instant.
            </p>
            <Link href={`${paths.batches_index}/new`} className="mt-4 inline-block">
              <Button>Créer le premier batch</Button>
            </Link>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Label</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Variantes</TableHead>
                <TableHead>Unités</TableHead>
                <TableHead>Coût direct</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {batches.map((b) => (
                <TableRow key={b.id}>
                  <TableCell className="font-medium">{b.label}</TableCell>
                  <TableCell>{b.produced_on ?? "—"}</TableCell>
                  <TableCell>{b.variant_count}</TableCell>
                  <TableCell>{b.total_units}</TableCell>
                  <TableCell>{formatEuros(b.direct_cost_cents)}</TableCell>
                  <TableCell className="text-right space-x-2">
                    <Link href={`${paths.batches_index}/${b.id}`}>
                      <Button variant="outline" size="sm">
                        Voir
                      </Button>
                    </Link>
                    <Link href={`${paths.batches_index}/${b.id}/edit`}>
                      <Button variant="outline" size="sm">
                        Éditer
                      </Button>
                    </Link>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => {
                        if (window.confirm("Supprimer ce batch ?")) {
                          router.delete(`${paths.batches_index}/${b.id}`)
                        }
                      }}
                    >
                      Supprimer
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </main>
    </>
  )
}
